/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'format-align-top': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M13 15l2.5 2.5 1.42-1.42L12 11.16l-4.92 4.92L8.5 17.5 11 15v6h2v-6M3 3h18v2H3V3m0 4h10v2H3V7z"/>'
  }
})
